export default "__VITE_ASSET__7fd5702b__"